import { ENTORNO } from "../utils/constantes";
import { getToken } from "../utils/variablesLocales";

export class apiListaBlanca {
  baseApi = ENTORNO.BASE_API;

  async obtener(email) {
    try {
      let url = "";
      if (email === "") {
        url = `${this.baseApi}/${ENTORNO.API_ROUTES.ListaBlanca_ObtenerTodas}`;
      } else {
        url = `${this.baseApi}/${ENTORNO.API_ROUTES.ListaBlanca_ObtenerTodas}?email=${email}`;
      }

      const parametros = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      const respuesta = await fetch(url, parametros);
      const respuestaJson = await respuesta.json();

      if (respuesta.status !== 200) throw respuestaJson;

      return respuestaJson;
    } catch (error) {
      throw error;
    }
  }

  async actualizar(Id, email) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.ListaBlanca_Actualizar}/${Id}`;

      const parametros = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          email: email,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async nuevo(email) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.ListaBlanca_Nuevo}`;

      const parametros = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          email: email,
        }),
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }

  async borrar(Id) {
    try {
      const url = `${this.baseApi}/${ENTORNO.API_ROUTES.ListaBlanca_Borrar}/${Id}`;

      const parametros = {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      };

      const respuesta = await fetch(url, parametros);
      return respuesta;
    } catch (error) {
      throw error;
    }
  }
}
